import { getAnchoredPaperSpacing } from '@components/v2/ui/utils/anchoredPaperSpacing';
import { PopoverOrigin, Theme } from '@mui/material';

export const PANEL_WIDTH = 324;
const PANEL_ANCHOR_GAP = 4;
const PANEL_ALIGNMENT_OFFSET = 8;
const OPTIONS_MENU_WIDTH = 228;
const OPTIONS_MENU_MAX_HEIGHT = 224;

export const PANEL_ANCHOR_ORIGIN: PopoverOrigin = { vertical: 'bottom', horizontal: 'right' };

export const PANEL_TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: -PANEL_ANCHOR_GAP,
  horizontal: PANEL_WIDTH - PANEL_ALIGNMENT_OFFSET,
};

export const panelPaperSx = {
  marginTop: 0,
  padding: 0,
};

export const optionsMenuPaperSx = (theme: Theme) => ({
  width: OPTIONS_MENU_WIDTH,
  overflow: 'hidden',
  ...getAnchoredPaperSpacing({ variant: 'dropdown' })(theme),
});

export const optionsMenuListSx = {
  maxHeight: OPTIONS_MENU_MAX_HEIGHT,
  overflowY: 'auto',
  paddingRight: 0.5,
};
